module.exports = __webpack_public_path__ + "static/media/21ECLAC45.4ea12116.jpg";